<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="9"
          ><div class="search-area-div">任务大类名称</div>
          <el-input clearable v-model="page.paramName" size="mini" class="ipt-sty" placeholder="请输入任务大类"></el-input
        ></el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'" >
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersion">新增任务大类</el-button>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="campaignsState"
          label="任务大类"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.paramName }}</template>
        </el-table-column>
        <el-table-column sortable prop="orderNum"  header-align="center" width="120" align="right">
          <template slot-scope="{}" slot="header">
          <el-popover trigger="hover" width="200" placement="top-start">
              <div>{{ '仅支持当前页面排序' }}</div>
              <template slot="reference">
                <i class="el-icon-question"></i>
              </template>
          </el-popover>
          <span>界面排序</span>
        </template>
          <template slot-scope="scope">{{ scope.row.orderNum }}</template>
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="更新人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateUserName||'-' }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="120px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="editVersion(scope.row)">编辑 ｜</a>
            <a class="txt-color" @click="delVersion(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50,100,200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="50%">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">任务大类 </span>
          <el-input type="input" :maxlength="30" placeholder="请输入任务大类名称" v-model="paramName"> </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label">界面排序 </span>
          <el-input type="input" placeholder="请输入，不填写自动生成" v-model="orderNum" 
          @input="orderNum = orderNum.replace(/[^\d]/g, '')"
          > </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="mini"
          type="info"
          v-if="textTitle == '新增任务大类'"
          @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="mini"
          type="info"
          v-else
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        bizType: '任务大类',
        paramName: '',
        tenantGuid:localStorage.guid,
      },
      paramName: '',
      orderNum:null,//界面排序
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      dialogVisible: false,
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    search() {
      let self = this;
      this.page.pageIndex = 1;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        bizType: '任务大类',
        paramName: '',
        tenantGuid:localStorage.guid,
        tenantName: JSON.parse(localStorage.userInfo).tenantName
      };
      this.getList();
    },
    addVersion() {
      this.textTitle = '新增任务大类';
      this.paramName = '';
      this.orderNum = null;
      this.dialogVisible = true;
    },
    editVersion(detail) {
      this.textTitle = '编辑任务大类';
      this.dialogVisible = true;
      this.guid = detail.guid;
      this.paramName = detail.paramName;
      this.orderNum = detail.orderNum ||null;
    },
    getList() {
      
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delVersion(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/delete?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    addReqVersion() {
      var self = this;
      if (!this.paramName) {
         self.$message.error('请输入任务大类名称');
        return;
      }
      
      var req = {
        paramName: this.paramName,
        orderNum: this.orderNum||null,
        bizType: '任务大类',
        tenantGuid:localStorage.guid,
        // tenantName: JSON.parse(localStorage.userInfo).tenantName
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      if (!this.paramName) {
         self.$message.error('请输入任务大类名称');
        return;
      }
      if (!this.orderNum) {
         self.$message.error('请输入界面排序');
        return;
      }
      var req = {
        bizType: '任务大类',
        paramName: this.paramName,
        orderNum: this.orderNum,
        guid: this.guid,
        tenantGuid:localStorage.guid,
        tenantName: JSON.parse(localStorage.userInfo).tenantName
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.el-col-9{
  display: flex;
  /* justify-content: flex-end; */
}
.ipt-sty{
  flex: 1;
}
.search-area-div{
  flex-shrink: 0;
  margin-right: 4px;
  width:86px;
  text-align:right

}
</style>